import React, { memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Link } from 'pcln-design-system'
import {
  ChevronUp as ChevronUpIcon,
  ChevronDown as ChevronDownIcon
} from 'pcln-icons'
import IconSet from './IconSet.js'

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  font-weight: ${props => props.fontWeight};
`
const StyledIcon = styled(IconSet)`
  margin-right: 16px;
`

function NavLink ({
  className,
  label,
  href,
  target,
  iconName,
  dropdownIconName,
  color,
  fontWeight,
  onClick
}) {
  return (
    <StyledLink
      className={className}
      key={label}
      href={href}
      color={color}
      fontWeight={fontWeight}
      target={target}
      rel='noopener'
      onClick={onClick}
      data-testid='nav-link'
    >
      {iconName && (
        <>
          <StyledIcon iconName={iconName} data-testid='nav-link-icon' />
        </>
      )}
      {label}
      {dropdownIconName &&
        dropdownIconName === 'ChevronDown' && (
        <ChevronDownIcon title='Dropdown Arrow' size={24} />
      )}
      {dropdownIconName &&
        dropdownIconName === 'ChevronUp' && (
        <ChevronUpIcon title='Upward Arrow' size={24} />
      )}
    </StyledLink>
  )
}

NavLink.displayName = 'NavLink'

NavLink.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  href: PropTypes.string,
  target: PropTypes.string,
  iconName: PropTypes.string,
  dropdownIconName: PropTypes.string,
  color: PropTypes.string,
  iconColor: PropTypes.string,
  fontWeight: PropTypes.string,
  onClick: PropTypes.func
}

NavLink.defaultProps = {
  className: ''
}

export default memo(NavLink)
